import { useSelector } from "react-redux";
import { RootState } from "@/store";

export function useSubAccount() {
  const { currentSubAccount, currentSubAccountInfo } = useSelector(
    (state: RootState) => state.subAccount,
  );
  const loading = useSelector((state: RootState) => state.subAccount.loading);
  const subAccounts = useSelector(
    (state: RootState) => state.subAccount.subAccounts,
  );
  return {
    currentSubAccount,
    subAccounts,
    currentSubAccountInfo,
    loading,
  };
}
